/**
 * Configuración centralizada de correos electrónicos
 *
 * Este archivo centraliza todas las direcciones de correo usadas en el sistema.
 * Modificar estos valores actualizará automáticamente todos los emails enviados.
 */

export const EMAIL_CONFIG = {
  /**
   * Correo para notificaciones automáticas del sistema
   * Usado en: invitaciones, verificaciones, notificaciones de pujas, etc.
   * Este correo NO debe esperar respuestas (no-reply)
   */
  noreply: 'no-reply@ingeniumforge.com',

  /**
   * Correo para comunicaciones bidireccionales y soporte
   * Usado en: emails masivos personalizados, contacto de soporte
   * Este correo SÍ puede recibir respuestas
   */
  info: 'info@ingeniumforge.com',
};